import React from 'react';
export const GuaranteeSection = () => {
  return <section className="bg-familia-bg py-10 md:py-16 px-4 md:px-6" data-id="element-99">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-100">
        <div className="bg-familia-card border-2 border-familia-gold p-8 md:p-16 rounded-[2rem] md:rounded-[2.5rem] text-center relative overflow-hidden" data-id="element-101">
          <div className="text-5xl md:text-7xl mb-6 md:mb-10" data-id="element-102">🛡️</div>
          <h2 className="text-[22px] sm:text-2xl md:text-4xl font-display font-bold mb-6 md:mb-8 uppercase tracking-wider" data-id="element-103">
            GARANTÍA VITALIDAD 360 — 30 DÍAS SIN PREGUNTAS
          </h2>
          <div className="text-familia-gray text-[15px] md:text-xl leading-relaxed mb-6 md:mb-10 max-w-xl mx-auto" data-id="element-104">
            <p className="mb-4" data-id="element-105">
              Probá el Master Kit completo durante 30 días. Usá las actividades,
              revisá los módulos, aplicá los registros.
            </p>
            <p data-id="element-106">
              Si sentís que no era lo que esperabas, escribinos y te devolvemos
              el 100% de tu dinero. Sin formularios complicados. Sin vueltas.
            </p>
            <p className="text-white font-bold mt-3 md:mt-4" data-id="element-107">
              Tu tranquilidad vale más que cualquier venta.
            </p>
          </div>
          <p className="text-familia-cyan text-[13px] md:text-sm font-medium mb-6 md:mb-10" data-id="element-108">
            Garantía de satisfacción de 30 días.
          </p>
        </div>
      </div>
    </section>;
};